import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { IconGraphy } from '@leapeasy/ui-kit';
import {
  MOBILE_SIDEBAR_OVERLAY_Z_INDEX,
  SIDEBAR_DESKTOP_MIN_WIDTH,
} from 'constants/layoutBreakpoints';
import { useFocusTrap } from 'hooks/useFocusTrap';

export const MobileSidebarDrawer = ({ children, onClose }) => {
  const panelRef = useRef(null);
  const closeButtonRef = useRef(null);

  useFocusTrap(panelRef, true, closeButtonRef);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  return (
    <Overlay role="presentation" onClick={onClose}>
      <Panel
        ref={panelRef}
        id="mobile-navigation-menu"
        role="dialog"
        aria-modal="true"
        aria-label="Navigation menu"
        onClick={(event) => event.stopPropagation()}
      >
        <CloseButton
          ref={closeButtonRef}
          type="button"
          aria-label="Close navigation menu"
          onClick={onClose}
        >
          <IconGraphy icon="General.Clear" width={18} height={18} forceColor />
        </CloseButton>
        {children}
      </Panel>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  z-index: ${MOBILE_SIDEBAR_OVERLAY_Z_INDEX};
  inset: 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;

  @media screen and (min-width: ${SIDEBAR_DESKTOP_MIN_WIDTH}) {
    display: none;
  }
`;

const Panel = styled.div`
  position: relative;
  flex-shrink: 0;
  min-height: 100%;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.24);
  }

  &:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;
